import { render, staticRenderFns } from "./veStuMoralProgramEdit.vue?vue&type=template&id=4ad159be&scoped=true"
import script from "./veStuMoralProgramEdit.vue?vue&type=script&lang=js"
export * from "./veStuMoralProgramEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad159be",
  null
  
)

export default component.exports